/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ColumnChooserColumnchooser$Params {
  columnNames?: string | null;
  type?: string | null;
  columnValue?: string | null;
}

export function columnChooserColumnchooser(http: HttpClient, rootUrl: string, params?: ColumnChooserColumnchooser$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, columnChooserColumnchooser.PATH, 'post');
  if (params) {
    rb.query('columnNames', params.columnNames, {});
    rb.query('type', params.type, {});
    rb.query('columnValue', params.columnValue, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

columnChooserColumnchooser.PATH = '/api/ColumnChooser/columnchooser/create';
